import React from "react";
import { toast } from "react-toastify";
import Popup from "reactjs-popup";
import { Grid, Card, Table, Page, colors, Form } from "tabler-react";
import { updateDoctorImage,updateDoctorImageArabic } from "../../services/user";

class ImageModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: this.props.openImageModal,
      fileObj: null,
      fileObjArabic:null,
      reload: false,
    };
    //this.openModal = this.props.openPopup;
    this.closeImageModal = this.closeImageModal.bind(this);

    this.onfileChange = this.onfileChange.bind(this);
    this.onfileChangeArabic = this.onfileChangeArabic.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleSubmitArabic = this.handleSubmitArabic.bind(this);
  }

  closeImageModal(reload = false) {
    this.props.onChange(false, reload);
  }

  submitReply(e) {
    this.props.onChange(false);
  }

  onfileChange(e) {
    console.log("on change english",e)
    if (e.target.files && e.target.files.length>0 && e.target.files[0]) {
      this.setState({ fileObj: e.target.files[0] });
    }
  }

  onfileChangeArabic(e) {
    console.log("on change arabioc",e)
    if (e.target.files && e.target.files.length>0 && e.target.files[0]) {
      this.setState({ fileObjArabic: e.target.files[0] });
    }
  }

  async handleSubmit(e) {
    try {
      e.preventDefault();

      if (this.state.fileObj) {
        console.log(formData,"formData_1")
        let formData = new FormData();
        formData.append("media", this.state.fileObj);
        updateDoctorImage(this.props.openImageModal.data, formData)
          .then(async (res) => {
            await this.setState({ reload: true });
            console.log(res);
            toast.success("Doctor English Image uploaded successfully.");
            this.closeImageModal(true);
          })
          .catch((error) => {
            if (error.response && error.response.data.message)
              toast.error(error.response.data.message);
            else if (error.message) toast.error(error.message);
            else toast.error(error);
          });

        // const res = await clientService.
      }
    } catch (error) {
      console.error(error);
    }
  }


  async handleSubmitArabic(e) {
    try {
      e.preventDefault();
      

      if (this.state.fileObjArabic) {
        let formData = new FormData();
        formData.append("media", this.state.fileObjArabic);
        console.log(formData,"formData_2")
        updateDoctorImageArabic(this.props.openImageModal.data, formData)
          .then(async (res) => {
            await this.setState({ reload: true });
            console.log(res);
            toast.success("Doctor Arabic Image uploaded successfully.");
            this.closeImageModal(true);
          })
          .catch((error) => {
            if (error.response && error.response.data.message)
              toast.error(error.response.data.message);
            else if (error.message) toast.error(error.message);
            else toast.error(error);
          });

        // const res = await clientService.
      }
    } catch (error) {
      console.error(error);
    }
  }

  render() {
    // console.log('admin-engage-score',this.props.openImageModal.data)
    const openImageModal = this.props.openImageModal.open;
    const replyOption = this.props.openImageModal.reply || this.state.reply;
    const message = this.props.openImageModal.data;
    console.log(
      "admin-engage-score",
      this.props,
      this.props.openImageModal,
      this.props.openImageModal.open,
      this.props.openImageModal.data
    );
    return (
      <div>
        <Popup
          open={openImageModal}
          onClose={this.closeImageModal}
          closeOnDocumentClick
        >
          <div className="card">
            <div className="card-header">
              <div className="card-options">
                <a
                  className="card-options-remove cursorPointer"
                  data-toggle="card-remove"
                  onClick={() => {
                    this.closeImageModal();
                  }}
                >
                  <i className="fe fe-x"></i>
                </a>
              </div>
            </div>
            <form
              className="card-body aligncenter"
              onSubmit={this.handleSubmit}
            >
              <div>
                <label htmlFor="file">Select English Image:</label>
                <input type="file" id="file" onChange={this.onfileChange} />
              </div>
              <button type="submit">Submit</button>
            </form>
            {/* <div>
            <form
              className="card-body aligncenter"
              onSubmit={this.handleSubmitArabic}
            >
              <div>
                <label htmlFor="file_ar">Select Arabic Image:</label>
                <input type="file" id="file_ar" onChange={this.onfileChangeArabic} />
              </div>
              <button type="submit">Submit</button>
            </form>
            </div> */}
          </div>
        </Popup>
      </div>
    );
  }
}

export default ImageModal;
